import React from "react";
import { ABUSE_TEMPLATES } from "../data/AbuseTemplates";
import TemplateGroup from "./TemplateGroup";

export default function TemplatesPanel({ toggles, onToggle }) {
	let idx = 0;
	return (
		<div className="space-y-8">
			{ABUSE_TEMPLATES.map((group, gIdx) => {
				const groupComponent = <TemplateGroup key={group.group} group={group.group} items={group.items} toggles={toggles} baseIdx={idx} onToggle={onToggle} />;
				idx += group.items.length;
				return groupComponent;
			})}
		</div>
	);
}
